var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVector3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 14,
    viewBox: "0 0 8 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.293063 12.2924C-0.0969373 12.6824 -0.0969373 13.3154 0.293063 13.7069C0.683063 14.0984 1.31606 14.0969 1.70756 13.7069L0.293063 12.2924ZM7.00106 6.99894L7.70756 7.70544C8.09756 7.31544 8.09756 6.68244 7.70756 6.29094L7.00106 6.99894ZM1.70756 0.292438C1.31756 -0.0975619 0.684562 -0.0975619 0.293062 0.292438C-0.0984378 0.682439 -0.0969378 1.31544 0.293062 1.70694L1.70756 0.292438ZM1.70756 13.7069L7.70756 7.70544L6.29306 6.29244L0.293063 12.2924L1.70756 13.7069ZM7.70756 6.29244L1.70756 0.292438L0.293062 1.70694L6.29306 7.70694L7.70756 6.29244Z",
    fill: "#8794AD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVector3);
export default __webpack_public_path__ + "static/media/Vector (3).c054674aa01ca9c5018819f9ddbe15a5.svg";
export { ForwardRef as ReactComponent };